import React, { useEffect, useRef, useState } from "react";
import jQuery from "jquery";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Spinner,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { MDBDataTableV5 } from "mdbreact";
import { useSelector } from "react-redux";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";

// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

// Require Font Awesome.
import "font-awesome/css/font-awesome.css";
import { BASE_URL } from "../utils/constants";
import axios from "axios";
import Swal from "sweetalert2";
import { RichBox } from "components/RichBoxComponent";

function IndProjects() {
  const permissions = useSelector((state) => state.permissions);
  const [proId, setProId] = useState("");
  const [projectFilter, setProjectFilter] = useState("current");
  const requestIdRef = useRef(0);
  const [selectedPrefs, setSelectedPrefs] = useState({
    template: "Default",
    bgcolor: "#ffffff",
    fgcolor: "#000000",
  });
  const [modalPrefs, setModalPrefs] = useState(false);
  const [projectModal, setProjectModal] = useState(false);
  const [datatable, setDatatable] = useState({
      columns: [
        {
          label: "#",
          field: "serial",
        },
        {
          label: "ID",
          field: "projectid",
        },
        {
          label: "Project Name",
          field: "projectname",
        },

        {
          label: "Controls",
          field: "controls",
        },
      ],
      rows: [
        {
          serial: <Spinner color="info" />,
          projectid: <Spinner color="info" />,
          projectname: <Spinner color="info" />,
          controls: <></>,
        },
      ],
    }),
    [formData, setFormData] = useState({
      title: "",
    }),
    [descModal, setDescModal] = useState(false);
  const [richBox,setRichBox] = useState("");
  const clearFormData = () => {
    setFormData((prevState) => ({ ...prevState, title: "" }));
    setRichBox("");
    setProjectModal(false);
  };

  const OpenProjectModal = async () => {
    await setProjectModal(true);

  };

  const handleDescModal = async (proj) => {
    await setDescModal(true);
    setRichBox(proj.description);
    let cont = jQuery.parseHTML(proj.description);
   
    let par = document.getElementById("description");
    cont.forEach((el) => {
      par?.appendChild(el);
    });
  };

  const changeHandler = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    let body = {
      title: formData.title,
      description: richBox,
      type: "individual",
      filter: projectFilter
    };
    Swal.showLoading();
    try {
      await axios.post(`${BASE_URL}/student/addproject.php`, body);
      await Swal.fire("Added Successfully", "", "success");
      clearFormData();
      await getProjects(projectFilter);
    } catch (e) {
     
      await Swal.fire("Something Went Wrong", "", "error");
    } finally {
      Swal.close();
    }
  };

  const handlePrefs = (e, proj) => {
    e.preventDefault();
    setProId(proj.id);
    setSelectedPrefs({
      template: proj.template || "Default",
      bgcolor: proj.bgcolor || "#ffffff",
      fgcolor: proj.fgcolor || "#000000",
    });
    setModalPrefs(true);
  };

  const handlSelect = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setSelectedPrefs((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmitPrefs = async (e) => {
    e.preventDefault();
    let body = {
      proId: proId,
      template: selectedPrefs.template,
      bgcolor: selectedPrefs.bgcolor,
      fgcolor: selectedPrefs.fgcolor,
    };

    try {
      await axios.post(`${BASE_URL}/student/setindprojectprefs.php`, body);
      await Swal.fire("Prefrences Stored Successfully!", "", "success");
    } catch {
      await Swal.fire("Error while sending prefrences", "", "error");
    } finally {
      setModalPrefs(false);
    }
  };
  useEffect(() => {
    getProjects(projectFilter);
  },[projectFilter]);
  const getProjects = (filter) => {
    const requestId = ++requestIdRef.current;
    Swal.showLoading();
    return axios
      .post(`${BASE_URL}/student/getindprojects.php`, {
        sId: permissions.id,
        filter,
      })
      .then((res) => {
        if (requestId !== requestIdRef.current) return;
        setDatatable((prevState) => {
          const newState = { ...prevState };
          let ser = 1;
          let newRows = (res.data.data?.indprojects || []).map((proj, key) => {
            return {
              ...proj,
              serial: ser++,
              projectid: proj.id,
              projectname: proj.name,
              controls: (
                <>
                  <div className="row justify-content-start p-3">
                    <a
                      className="col-3 w-75 my-1 btn btn-info"
                      onClick={() => handleDescModal(proj)}
                    >
                      Show
                    </a>

                    <Link
                      className="col-3 w-75 my-1 btn btn-success fw-bolder col-2"
                      to={`/projects/${proj.id}`}
                    >
                      Progress
                    </Link>

                    <a
                      className="col-3 w-75 my-1  btn btn-primary fw-bolder col-2"
                      onClick={(e) => handlePrefs(e, proj)}
                    >
                      Preferences
                    </a>

                    <a
                      className="col-3 w-75 my-1 btn btn-secondary fw-bolder col-2"
                      target="_blank"
                      disabled={
                        proj?.math_connection == null &&
                        proj?.ela_connection == null &&
                        proj?.sse == null &&
                        proj?.about_school == null &&
                        proj?.engandtech == null
                      }
                      href={`${BASE_URL}/previewip.php?id=${res.data.data.hashes[key]}`}
                    >
                      Preview
                    </a>
                  </div>
                </>
              ),
            };
          });

          return { ...newState, rows: newRows };
        });
      })
      .catch(() => {
        if (requestId !== requestIdRef.current) return;
        Swal.fire("Something Went Wrong", "", "error");
      })
      .finally(() => {
        if (requestId !== requestIdRef.current) return;
        Swal.close();
      });
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card className="w-100">
              <CardHeader>
                <h4 className="title">Projects</h4>
              </CardHeader>
              <div className="text-center">
                <button
                  className="btn btn-primary fw-bolder mx-auto w-25"
                  onClick={() => {
                    OpenProjectModal();
                  }}
                >
                  Add Project
                </button>
              </div>

              <CardBody className="all-icons">
                <div>
                  <div className="form-check form-check-inline ">
                    <input
                      className="form-check-input"
                      style={{ marginRight: "-20%" }}
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      checked={projectFilter === "current"}
                      onChange={(e) => {
                        setProjectFilter("current");
                      }}
                      value="option1"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">
                      Current Projects
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      style={{ marginRight: "-20%" }}
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      onChange={(e) => {
                        setProjectFilter("archived");
                      }}
                      id="inlineRadio2"
                      checked={projectFilter === "archived"}
                      value="option2"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">
                      Archived Projects
                    </label>
                  </div>
                </div>
                
                  <MDBDataTableV5
                    hover
                    responsive
                    bordered
                    borderless={false}
                    striped
                    entriesOptions={[5, 20, 25]}
                    entries={10}
                    pagesAmount={4}
                    data={datatable}
                    fullPagination
                    searchTop
                    searchBottom={false}
                  />
                
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={descModal}
          size="fullscreen"
          className="custom-modal-style"
        >
          <ModalHeader className="bg-info fw-bolder">
            Project Details
          </ModalHeader>
          <ModalBody>
            {/* <div id="parent"></div> */}
            <RichBox
                      onChange={(data)=>{setRichBox(data);}}
                    
                      defaultValue={richBox}
                      height={"10px"}
                    ></RichBox>   
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-secondary"
              onClick={() => setDescModal(false)}
            >
              Close
            </button>
          </ModalFooter>
        </Modal>

        {/* **********************Prefs Modal********************** */}
        <Modal isOpen={modalPrefs} size="md" className="pref-modal">
          <ModalHeader className="bg-info fw-bolder">
            Project Preferences
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={(e) => handleSubmitPrefs(e)}>
              <Label htmlFor="templ">Select Template:</Label>
              <Input
                id="templ"
                name="template"
                onChange={(e) => handlSelect(e)}
                value={selectedPrefs.template}
                type="select"
                required
              >
                <option defaultValue={true} value="Default">
                  Default
                </option>
              </Input>
              <br />
              <Label htmlFor="bgclr">Select Background-Color:</Label>
              <Input
                id="bgclr"
                name="bgcolor"
                onChange={(e) => handlSelect(e)}
                type="color"
                value={selectedPrefs.bgcolor}
              ></Input>
              <br />
              <Label htmlFor="fgclr">Select Foreground-Color:</Label>
              <Input
                id="fgclr"
                name="fgcolor"
                onChange={(e) => handlSelect(e)}
                type="color"
                value={selectedPrefs.fgcolor}
              ></Input>
              <br />
              <Input
                type="submit"
                value="submit"
                className="btn btn-primary mt-1 mx-auto fs-6 fw-bolder"
              />
            </Form>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-secondary"
              onClick={() => setModalPrefs(false)}
            >
              Close
            </button>
          </ModalFooter>
        </Modal>
        {/* **********************Add Project Modal********************** */}
        <Modal isOpen={projectModal} size="md" className="pref-modal">
          <ModalHeader className="bg-info fw-bolder">Add Project</ModalHeader>
          <ModalBody>
            <Form onSubmit={(e) => submitHandler(e)}>
              <Row>
                <Col md={12}>
                  <div className="col-12">
                    <label
                      className="fs-6 ms-3 mt-3 fw-bolder text-primary"
                      htmlFor="proname"
                    >
                      Name
                    </label>
                    <br />
                    <Input
                      className="w-100 text-center fw-bolder text-info fs-5"
                      type="text"
                      name="title"
                      id="proname"
                      value={formData.title}
                      placeholder="Type project name here....."
                      style={{ height: "50px" }}
                      onChange={changeHandler}
                    />
                  </div>

                  <div className="col-12" id="bodyarea">
                    <label className="fs-6 ms-3 mt-3 fw-bolder text-primary">
                      Description
                    </label>
                    <RichBox
                      onChange={(data)=>{setRichBox(data);}}
                    
                      defaultValue={richBox}
                      height={"10px"}
                    ></RichBox>                      <div id="rich"></div>
                  </div>
                  <div className="text-center">
                    <button
                      className="btn btn-primary w-25 fw-bolder mx-auto"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                  <hr />
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setProjectModal(false);
                clearFormData();
              }}
            >
              Close
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default IndProjects;
